// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3uaCQ","row":"styles_row__2YYGV"};